import { SanityArticle, SanityArticleTeaser } from 'types/sanity/education-center';

/**
 * Maps an array of `SanityArticle` objects, transforming articles marked as investor updates.
 *
 * For each article:
 * - If `isInvestorUpdate` is true and a `sourceInvestorUpdate` exists,
 *   it replaces the `keyTakeaways`, `body`, and `footnotes` fields with corresponding values
 *   from the `sourceInvestorUpdate` object.
 * - Otherwise, returns the article unchanged.
 *
 * @param articles - Array of `SanityArticle` objects to be mapped.
 * @returns A new array of `SanityArticle` objects with investor update details mapped.
 */

// Maps investor update articles to their teaser representation
export function mapInvestorUpdateArticleTeasers(articles: SanityArticle[]): SanityArticleTeaser[] {
	return articles.map((article) => {
		if (article?.isInvestorUpdate && article?.sourceInvestorUpdate) {
			return {
				...article,
				coverImage: article.sourceInvestorUpdate.thumbnail,
				subtitle: article.sourceInvestorUpdate.subtitle
			};
		}
		return article;
	});
}

// Maps investor update article to their detailed representation on the article page
export function mapInvestorUpdateArticleDetailPage(article: SanityArticle): SanityArticle {
	if (article?.isInvestorUpdate && article?.sourceInvestorUpdate) {
		return {
			...article,
			subtitle: article.sourceInvestorUpdate.subtitle,
			coverImage: article.sourceInvestorUpdate?.coverMedia?.mediaItems?.[0]?.thumbnail ?? undefined,
			keyTakeawaysSection: article.sourceInvestorUpdate?.keyTakeawaysSection,
			body: article.sourceInvestorUpdate?.updateBody,
			footnotes: article.sourceInvestorUpdate?.disclaimer
		};
	}
	return article;
}
